<template>
  <div
    class="accordion"
    :class="{ 'accordion-transition': Accordion.transition }"
  >
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'AppAccordion',
  provide() {
    return { Accordion: this.Accordion };
  },
  props: {
    active: {
      type: Number,
      default: null,
    },
  },
  data: () => ({
    Accordion: {
      count: 0,
      active: null,
      transition: false,
    },
  }),
  watch: {
    active: {
      handler(value) {
        if (value !== null) {
          this.Accordion.active = value;
        }
        this.$emit('update:active', null);
      },
      immediate: true,
    },
  },
};
</script>
